import { render, staticRenderFns } from "./view-noticias-voluntariado.vue?vue&type=template&id=30c79202&scoped=true"
import script from "./view-noticias-voluntariado.vue?vue&type=script&lang=js"
export * from "./view-noticias-voluntariado.vue?vue&type=script&lang=js"
import style0 from "./view-noticias-voluntariado.vue?vue&type=style&index=0&id=30c79202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c79202",
  null
  
)

export default component.exports